import * as React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
} from '@mui/material';
import { Link } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

function SideBarItem({ label, link, Icon, open, submenu }) {
  const [openSubmenu, setOpenSubmenu] = React.useState(false);

  const handleSubmenuToggle = () => {
    setOpenSubmenu(!openSubmenu);
  };

  return (
    <>
      <ListItem disablePadding sx={{ display: 'block' }}>
        <Link to={link}>
          <ListItemButton
            onClick={submenu && submenu.length > 0 ? handleSubmenuToggle : null}
            sx={{
              minHeight: 48,
              justifyContent: open ? 'initial' : 'center',
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 3 : 'auto',
                justifyContent: 'center',
              }}
            >
              <Icon />
            </ListItemIcon>
            <ListItemText
              primary={label}
              sx={{
                opacity: open ? 1 : 0,
                '.MuiTypography-root': {
                  color: '#fff',
                  fontSize: '16px',
                  lineHeight: '1',
                  fontWeight: '500',
                },
              }}
            />
            {submenu && submenu.length > 0 && open && (
              <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                {openSubmenu ? (
                  <ExpandLessIcon color="secondary" />
                ) : (
                  <ExpandMoreIcon color="secondary" />
                )}
              </ListItemIcon>
            )}
          </ListItemButton>
        </Link>
      </ListItem>
      {submenu && submenu.length > 0 && open && (
        <Collapse in={openSubmenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {submenu.map((subItem, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  component={Link}
                  to={subItem.link || '#'}
                  sx={{ pl: 4 }}
                >
                  <ListItemText
                    primary={subItem.label}
                    sx={{
                      '.MuiTypography-root': {
                        color: '#fff',
                        fontSize: '14px',
                        lineHeight: '1',
                        fontWeight: '400',
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

export default SideBarItem;
